module.exports = __webpack_public_path__ + "img/_logo.5f80c330.png";